import './App.css';
import { useState, useEffect } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import Login from './containers/login/Login';
import Issue from "./containers/issue/Issue"
import IssueTable from './containers/issueTable/IssueTable';
import AuthGuard from './AuthGuard';
import Maintainence from './components/maintainence/maintainence';
import envUrls from './utils/config';
import Preview from './containers/previewPage/preview';
import About from './containers/aboutpage/About';
import { toast } from 'react-toastify';
import AssingedBy from './containers/AssingedBy/AssingedBy';
import ReportedBy from './containers/ReportedBy/ReportedBy';
import { clearAuthCookies } from './utils/authCookies';

function App() {
  const notifyValidationsWarns = (msg) => {
    toast.clearWaitingQueue();
    toast(msg, {

      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: false,

    })
  };
  function getCookie(name) {
    var found = document.cookie.split(';').filter(c => c.trim().split("=")[0] === name);
    return found.length > 0 ? found[0].split("=")[1] : null;
  }
  function hasValidToken() {
    var t = getCookie('Authorization_windbug');
    return t !== null && t !== '' && t !== 'undefined' && t !== 'null';
  }
  // Read the cookie synchronously on the very first render so protected routes
  // never mount (and never fire an authenticated API call) before we know
  // whether the user is logged in. Starting this as `true` was the reason a
  // fresh visitor briefly hit /issues, got a 401, and saw "Session expired".
  // An API call just returned 401, so the token cookie is dead. Remove it
  // before anything reads it; otherwise it lingers until its 60 min client
  // expiry and can be sent alongside the new token after re-login.
  if (sessionStorage.getItem('session_expired') === 'true') {
    clearAuthCookies();
  }
  const [isAuth, setIsAuth] = useState(hasValidToken);
  useEffect(() => {
    setIsAuth(hasValidToken());
  }, [])

  useEffect(() => {
    var loggingOut = sessionStorage.getItem('logging_out') === 'true'
    // Only warn when an API call returned 401 while the user was in the app.
    // Simply opening the site with an expired/missing token shows the plain
    // login page, without a "session expired" message.
    if (!loggingOut && sessionStorage.getItem('session_expired') === 'true') {
      notifyValidationsWarns('Session expired, Please login again')
    }
    localStorage.removeItem('had_session')
    sessionStorage.setItem('session_expired', 'false')
    sessionStorage.setItem('logging_out', 'false')
  }, [])

  return (
    <BrowserRouter>
      {envUrls.isMaintainence ? (
        <Switch>
          <Route path={"/maintainence"} exact component={Maintainence} />
          <Route path={"/"}>
            <Redirect to={"/maintainence"} />
          </Route>
          <Route path={"*"}>
            <Redirect to={"/maintainence"} />
          </Route>
        </Switch>
      ) : (
        <Switch>
          <AuthGuard path={"/about"} component={About} isAuth={isAuth} />
          <AuthGuard path={"/issues"} component={IssueTable} isAuth={isAuth} />
          <AuthGuard path={"/issue/:id"} component={Issue} isAuth={isAuth} />
          <Route path={"/login"} exact component={Login} />
          <AuthGuard path={"/assigned"} exact component={AssingedBy} isAuth={isAuth} />
          <AuthGuard path={"/reported"} exact component={ReportedBy} isAuth={isAuth} />
          {isAuth ? (
            <Route path={"/"}>
              <Redirect to={"/issues"} />
            </Route>
          ) : (
            <Route path={"/"}>
              <Redirect to={"/login"} />
            </Route>
          )}
        </Switch>
      )}
    </BrowserRouter>
  );
}

export default App;
